/**
 * Resolves which city should be pre-selected in the store locator UI. This is a
 * presentation-only concern (it only exists to drive the shell's initial selection),
 * so it's typed against `StoreCityGroupVm` and lives under `presentation/` rather than
 * the feature-root `utils/` (whose `findCityKey`/`getCityList` are shared with `plp`).
 */
import { DEFAULT_STORE_LOCATOR_CITY } from '../../constants';
import { findCityKey } from '../../utils/storeListUtils';
import type { StoreCityGroupVm } from '../viewModels/physicalStore.vm';

/** Resolve a preferred city name to a key in the stores map; falls back to default then first city. */
export function resolveStoreLocatorCityKey(
  cityGroups: StoreCityGroupVm[],
  preferredCityName?: string
): string {
  if (cityGroups.length === 0) return '';

  const cityToStoresMap = Object.fromEntries(
    cityGroups.map((group) => [group.cityName, group.stores])
  );
  const preferred = preferredCityName?.trim() || DEFAULT_STORE_LOCATOR_CITY;

  return findCityKey(cityToStoresMap, preferred) ?? cityGroups[0]?.cityName ?? '';
}
